module.exports = window["wp"]["keyboardShortcuts"];